import { CommunicationType } from '../enums/communicationType.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commTypeDescriptionPipe',
})
export class CommTypeDescriptionPipe implements PipeTransform {
    transform(type: any): any {
        switch (type) {
            case CommunicationType.REMINDER:
                return 'Opomnik';
            case CommunicationType.SURVEY:
                return 'Anketa';
            case CommunicationType.INVOICE_ACCESS:
                return 'Dostop do računa';
            // case CommunicationType.DIAGNOSIS_ACCESS:
            //     return 'Dostop do diagnoze';
            case CommunicationType.DOCUMENTATION_ACCESS:
                return 'Dostop do dokumentacije';
            case CommunicationType.RESERVATION_NOTICE:
                return 'Rezervacija termina';
            case CommunicationType.RESERVATION_CHANGE_NOTICE:
                return 'Sprememba termina';
            case CommunicationType.RESERVATION_REMINDER:
                return 'Opomnik na termin';
            case CommunicationType.RESERVATION_CANCEL:
                return 'Preklic rezervacije';
            case CommunicationType.SLOT_RESERVATION:
                return 'Rezervacije terminov';
            case CommunicationType.NEW_SUBCONTRACTOR_REQUEST:
                return 'Zahteva za novega podizvajalca';
            case CommunicationType.ACCESS_CODE:
                return 'Koda za dostop';
            case CommunicationType.PWD_RENEWAL:
                return 'Obnova gesla';
            // case CommunicationType.PASSWORD_RENEWAL:
            //     return 'Obnova gesla';
            case CommunicationType.GDPR_PERMISSION:
                return 'GDPR privolitve';
            case CommunicationType.TELEMEDICINE:
                return 'Telemedicina';
            case CommunicationType.COVID19:
                return 'Covid vprašalnik';
            case CommunicationType.UNANSWERED_CALL:
                return 'Neodgovorjen klic';
            default:
                return type;
        }
    }
}
